<div class="loading-overlay-chat">
  <div class="dots">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
